import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import { Constants } from "../../../CommonMethhods/Constants";
import Snapshot from "../../Dashboard/DashBoardDefault/Snapshot";
import RevenueSnapshot from "../../Dashboard/DashBoardDefault/RevenueSnapshot";
import AumSnapshot from "../../Dashboard/DashBoardDefault/AumSnapshot";
import SalesSnapShot from "../../Dashboard/DashBoardDefault/SalesSnapShot";
import ClientSnapshot from "../../Dashboard/DashBoardDefault/ClientSnapshot";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { partner_Api } from "../../../Configuration/Partner_URL";
import PartnerSideSnapshot from "./PartnerSideSnapshot";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { Modal } from "react-bootstrap";

function PartnerSnapshotBusinessSnapshot(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerId = localStorage.getItem("partnerId");
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");

  const [onboarded, setOnboarded] = useState();
  const [brokerage, setBrokerage] = useState();
  const [mtf, setMtf] = useState();
  const [paidAccounts, setPaidAccounts] = useState();
  const [chartRevenueEq, setChartRevenueEq] = useState(null);
  const [chartRevenueFno, setChartRevenueFno] = useState(null);
  const [chartRevenueTotal, setChartRevenueTotal] = useState(null);
  const [chartAumEq, setChartAumEq] = useState(null);
  const [chartAumFno, setChartAumFno] = useState(null);
  const [chartAumTotal, setChartAumTotal] = useState(null);
  const [NotTradedWMargin, setChartClientNotTradedWMargin] = useState(null);
  const [NotTradedWOMargin, setChartClientNotTradedWOMargin] = useState(null);
  const [loader, setLoader] = useState(false);
  const [businessFilter, setBusinessFilter] = useState("Monthly");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customDate, setCustomDate] = useState(false);


  
  const getBuisnessSnapshotDetails = async (dayWise) => {
    setLoader(true);
    try {
      const getBuisnessDetails = await axios.get(
        `${partner_Api.GET_BUSINESS_SNAPSHOT}?pCode=${partnerId}&range=${dayWise}&to=${toDate}&from=${fromDate}`,
        
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );

      const responseData = decryptData(getBuisnessDetails?.data);
      let decryptRespData = JSON.parse(responseData);
      if(decryptRespData?.status === 0){
      setOnboarded(decryptRespData?.data?.info?.clientOnboarded);
      setBrokerage(decryptRespData?.data?.info?.brokerage);
      setMtf(decryptRespData?.data?.info?.mtfBook);
      setPaidAccounts(decryptRespData?.data?.info?.paidAccounts);
      
      }
    } catch (error) {
      console.log(error);
    }
    finally{
      setLoader(false);
    }
  };


  const handleBusinessFilterChange = (e) => {
    if (e?.target?.value !== "Custom") {
      setBusinessFilter(e?.target?.value);
      setFromDate("");
      setToDate("");
    } else{
      setBusinessFilter(e?.target?.value);

      // setBusinessFilter("");
      setCustomDate(true);

    }
  };


  useEffect(() => {
    if(partnerId && businessFilter === "Custom"){
      if(fromDate?.length > 0 && toDate?.length > 0){
        getBuisnessSnapshotDetails(businessFilter);
      }
    }else{
      getBuisnessSnapshotDetails(businessFilter);
    }
  }, [businessFilter, partnerId]);

  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            getBuisnessSnapshotDetails(businessFilter);
            setCustomDate(false);
          }}
        >
          Submit
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Submit
        </button>
      );
    }
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  return (
    <>
      <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.BusinessSnapshot}</h2>
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="dropdown-filter">
              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={handleBusinessFilterChange}
              >
                <option value="Yesterday">Yesterday</option>
                <option value="Weekly">{Constants.Weekly}</option>
                <option value="Monthly" selected>{Constants.Monthly}</option>
                <option value="Yearly">{Constants.Yearly}</option>
                <option value="Quarterly">{Constants.Quarterly}</option>
                <option value="Till Now">Till Now</option>
                <option value="Custom">Custom</option>

              </Form.Select>
            </div>
          </div>
        </div>
        {/* <!-- Revenue Tab CSS --> */}
        <div
          className="accordion accordion-flush revenue-accordian"
          id="accordionFlushExample"
        >
          <div className="accordion-item">
            <div className="row">
              <PartnerSideSnapshot
                title="Total Clients Onboarded"
                dataTarget="#flush-collapseOne"
                businessFilter={businessFilter}
                textfield={"Overall Client Revenue"}
                snapshotData={
                  onboarded === null || undefined ? true : onboarded
                }
                isActive={true}
                loader={loader}
                chartEq={
                  chartRevenueEq === undefined || null ? true : chartRevenueEq
                }
                chartFno={
                  chartRevenueFno === undefined || null ? true : chartRevenueFno
                }
                chartTotal={
                  chartRevenueTotal === undefined || null
                    ? true
                    : chartRevenueTotal
                }
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="Revenue"
              />
              <PartnerSideSnapshot
                title="Total Brokerage"
                businessFilter={businessFilter}
                textfield={"Total Brokerage Generated"}
                dataTarget="#flush-collapseTwo"
                snapshotData={
                  brokerage === null || undefined ? true : brokerage
                }
                isActive={true}
                chartFno={
                  chartAumFno === undefined || null ? true : chartAumFno
                }
                chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                chartTotal={
                  chartAumTotal === undefined || null ? true : chartAumTotal
                }
                loader={loader}
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="AUM"
              />
              <PartnerSideSnapshot
                title="MTF Book"
                businessFilter={businessFilter}
                textfield={"MTF book as of Today"}
                dataTarget="#flush-collapseThree"
                snapshotData={
                  mtf === null || undefined ? true : mtf
                }
                // chartFno={
                //   chartAumFno === undefined || null ? true : chartAumFno
                // }
                // chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                // chartTotal={
                //   chartAumTotal === undefined || null ? true : chartAumTotal
                // }
                loader={loader}
                isActive={true}
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="AUM"
              />
              <PartnerSideSnapshot
                title="Total Paid Accounts"
                businessFilter={businessFilter}
                textfield={"Total Clients under Professional & BPC Pack"}
                dataTarget="#flush-collapseFour"
                snapshotData={
                  paidAccounts === null || undefined ? true : paidAccounts
                }
                isActive={false}
                chartEq={
                  NotTradedWMargin === undefined || null
                    ? true
                    : NotTradedWMargin
                }
                chartFno={
                  NotTradedWOMargin === undefined || null
                    ? true
                    : NotTradedWOMargin
                }
                chartTotal={
                  (NotTradedWMargin === undefined || null
                    ? true
                    : NotTradedWMargin) +
                  (NotTradedWOMargin === undefined || null
                    ? true
                    : NotTradedWOMargin)
                }
                ChartName1="Not Traded w/ Margin"
                ChartName2="Not Traded w/o Margin"
                loader={loader}
                titleForGraph="Client"
              />
            </div>
            
          </div>
        </div>
      </div>
      {customDate && customDate ? (
          <Modal
            show={customDate}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="setting-model partner-modal-rejection"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                <h2 className="model-title">Custom Date</h2>
              </Modal.Title>
              <button type="button" className="btn-close" aria-label="Close">
                <span
                  className="icon-close"
                  onClick={() => setCustomDate(false)}
                ></span>
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="custom-modal-wrapper row">
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.From_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setFromDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.To_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setToDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <SubmitButton />
            </Modal.Footer>
          </Modal>
        ) : null}
    </>
  );
}

export default PartnerSnapshotBusinessSnapshot;
